<template>
<v-container 
  fluid 
  fill-height 
  justify-center
  align-center
>
  <v-flex xs12 sm12 md8 lg4>
    <v-card>
      <v-toolbar color="primary">
        <v-toolbar-title class="white--text">Reset password</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex>
          <p>Please enter your email and follow instructions on how to reset your password.</p>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
              label="E-mail"
              v-model="email"
              :rules='rules.emailRules'
              required
            ></v-text-field>
            <v-btn
              @click.prevent="reset"
              :disabled="!valid"
            >
              reset
            </v-btn>
          </v-form>
        <div row>
            <v-alert
              class="auth"
              :color="alert.type"
              icon="check_circle"
              :value="alert.status"
              transition="scale-transition"
            >
              {{ alert.message }}
            </v-alert>
          </div>
        </v-flex>
      </v-card-title>
      <v-footer>
      </v-footer>
    </v-card>
  </v-flex>
</v-container>
</template>

<script>
import axios from "axios";
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
    data: () => ({
      valid: false,
      email: '',
      rules: {
        emailRules: [
          v => !!v || "E-mail is required",
          v =>
            /\S+@\S+\.\S+/.test(v) ||
            "E-mail must be valid"
        ]
      },
      e1: true,
      alert: {
        status: false,
        message: '',
        type: ''
      },
      errorMessage: ''
    }),
    methods: {
      alerting(){
        this.alert.status = !this.alert.status;
        setTimeout(() => {
              this.alert.status = !this.alert.status;
          }, 5000);
      },
      reset () {
        let vm = this;
         axios.post('/token/request', {
            email: this.email
          })
          .then(res => {
            vm.alert.message = 'Check your email and follow the instructions to change your password.'
            vm.alert.type = 'success'
            vm.alerting()
          })
          .catch(err => {
            vm.alert.message = 'There was an error, please contact administrator.'
            vm.alert.type = 'error'
            vm.alerting();
          });
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/auth/Reset.vue